import * as React from "react";
import PropTypes from "prop-types";
import ErrorHandler from "nexia_mobile/components/ErrorHandler";

const TileControlWrapper = ({ children }) => {
  const styles = {
    wrapper: {
      height: "3em",
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "#F0F0F0",
    },
    controlWrap: {
      margin: "0 0.5em",
    },
  };

  return (
    <ErrorHandler>
      <div style={styles.wrapper} data-component-name="TileControlWrapper">
        <div className="device-control-wrap" style={styles.controlWrap}>
          {children}
        </div>
      </div>
    </ErrorHandler>
  );
};
TileControlWrapper.propTypes = {
  children: PropTypes.element,
};

export default TileControlWrapper;



// WEBPACK FOOTER //
// ./src/components/Controls/wrappers/TileControlWrapper.jsx